import parse from 'html-react-parser';
import { useNavigate } from 'react-router-dom';

import RelativeDate from '../../../../components/RelativeDate';
import { ImgProxyResizer } from '../../../../utils/ImageProxyResizer';
import { NotificationActionType } from '../../../../utils/notifications/NotificationHandler';
import { getInitials } from '../../../../utils/User';
import { UnclickedContainer, UnclickedIndicator } from '../NotificationsPage.styles';
import {
  AvatarContainer,
  AvatarImage,
  Container,
  DotSeparator,
  Label,
  LeftContainer,
  Line,
  NotificationText,
  VehicleImage,
  VehicleImageContainer,
  //UserBlock,
} from './NotificationsItem.styles';

interface User {
  firstName: string;
  lastName;
  avatarUrl?: string;
}

export interface NotificationsItemProps {
  id: string;
  title: string;
  date: string;
  user?: User;
  vehicleImgUrl?: string;
  isRead?: boolean;
  entityId?: string;
  markAsRead?: () => void;
  action: string;
  isToast?: boolean;
}

export const NOTIFICATION_KEY = 'notification';

export const NotificationsItem = ({
  title,
  user,
  date,
  vehicleImgUrl,
  markAsRead,
  action,
  entityId,
  isRead,
  isToast,
}: NotificationsItemProps) => {
  const navigate = useNavigate();

  const resizedVehicleImgUrl = new ImgProxyResizer(vehicleImgUrl).smallUrl;

  const onNotificationClick = () => {
    if (!isRead) {
      markAsRead?.();
    }

    switch (action) {
      case NotificationActionType.bulkCreate:
        navigate('/app/listings/');
        break;
      case NotificationActionType.mention:
        navigate(`/app/listings/${entityId}/activity#activity`);
        break;
      default:
        navigate(`/app/listings/${entityId}`, { state: { origin: NOTIFICATION_KEY } });
        break;
    }
  };

  const parseHtmlTitle = () => {
    try {
      return parse(title);
    } catch {
      return title;
    }
  };

  return (
    <Container onClick={onNotificationClick} $isToast={isToast}>
      <Line>
        <VehicleImageContainer $display={!!resizedVehicleImgUrl}>
          <VehicleImage src={resizedVehicleImgUrl} />
        </VehicleImageContainer>
        <NotificationText>
          {parseHtmlTitle()}
          <Label>{<RelativeDate date={date} />}</Label>
        </NotificationText>
      </Line>
      {user && (
        <Line>
          <LeftContainer>
            {user && (
              <>
                <AvatarContainer>
                  <AvatarImage text={getInitials(user.firstName, user.lastName)} src={user.avatarUrl} />
                </AvatarContainer>
                <Label>{[user.firstName, user.lastName].join(' ')}</Label>
                <DotSeparator>{'•'}</DotSeparator>
              </>
            )}
          </LeftContainer>
        </Line>
      )}
      {!isRead && (
        <UnclickedContainer
          onClick={(e) => {
            e.stopPropagation();
            markAsRead?.();
          }}
        >
          <UnclickedIndicator />
        </UnclickedContainer>
      )}
    </Container>
  );
};

export default NotificationsItem;
